
<template>
  <b-container 
    fluid 
    class="my-4"
  >
    <b-spinner 
      v-show="busy" 
      type="border" 
      small
    />
    <b-row>
      <b-col cols="4">
        <b-overlay 
          :show="busy" 
          variant="dark"
        >
          <b-card-title>
            Uploaden van documenten
          </b-card-title>
          <b-form-group
            :description="uploadAPIPath"
          >
            <b-input-group 
              prepend="Document ter beoordeling" 
              style="z-index: 10"
            >
              <b-file
                v-model="nieuwdocument.document"
                accept=".pdf,.PDF"
                placeholder="Kies bestand of sleep hier in..."
                drop-placeholder="Laat maar los..."
                browse-text="Kies bestand"
              />
            </b-input-group>
          </b-form-group>
           
          <b-button 
            class="pull-right" 
            @click="startDirectUpload()"
          >
            Upload
          </b-button>
        </b-overlay>
        <b-alert v-model="uploadResponse" />
      </b-col>
      <b-col 
        v-if="nieuwdocument.document" 
        cols="5"
      >
        <b-card 
          id="pdf-scroll" 
          title="PDF Preview" 
          class="h-50"
        >
          <pdf :src="pdfPreview" />
        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import pdf from "vue-pdf";
import { serviceMixin } from "@/mixins/serviceMixin.js";

const base64Encode = data =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(data);
    reader.onload = () => resolve(reader.result);
    reader.onerror = error => reject(error);
  });

export default {
  components: {
    pdf,
  },
  mixins: [serviceMixin],
  data() {
    return {
      profiel: null,
      contactpersonen: [],
      currentPage: 1,
      uploadResponse: null,
      nieuwdocument: {
        document: null,
        documentType: 0,
        documentStatus: "Ter controle",
        documentTonen: true,
        soortOnderhoud: "Correctief",
        verzenddatum: null,
        bedrag: 0,
        kenmerk: '',
        opmerking: 'Ter beoordeling test',
        vanRelatie: null,
        aanRelatie: null,
        aanContactpersoon: null
      },
      busy: false,
      relaties: [],
      pdfPreview: null,
      typeOnderhoud: [
        "Correctief",
        "Diverse",
        "Keuringen",
        "Planmatig",
        "Preventief",
      ],
      typeStatus: [
        "Afgekeurd",
        "Ter controle",
        "Goedgekeurd",
        "Opdracht",
        "Afgerond",
      ],
      docTypes: [
        { value: 0, text: "Geen" },
        { value: 1, text: "p.a. Factuur" },
        { value: 2, text: "Factuur/termijn" },
        { value: 3, text: "Offerte" },
        { value: 4, text: "PVB" },
        { value: 5, text: "Keuring" },
        { value: 6, text: "Kwartaaloverleg  " },
        { value: 7, text: "Algemeen" },
        { value: 8, text: "Bestek" },
        { value: 9, text: "Storingsoverzicht" },
        { value: 10, text: "Factuur" },
        { value: 11, text: "Onderhoudscontract" },
        { value: 12, text: "Planning" },
        { value: 13, text: "Intern document" },
      ],
    };
  },
  computed: {
    uploadAPIPath: function () {
      return `/documenten/${this.uploadFolder}/${new Date().getUTCFullYear()}/upload`;
    },
    uploadFolder: function () {
      return this.profiel ? this.profiel.auth.user.Bedrijf.Naam.toLowerCase().split(' ')[0] : 'nosli';
    },
    canDirectUploadStart: function() {
      if (!this.nieuwdocument.document) return false
      if (!this.nieuwdocument.vanRelatie) return false
      if (!this.nieuwdocument.aanRelatie) return false
      if (!this.nieuwdocument.documentType == 0) return false
    }
  },
  watch: {
    "nieuwdocument.document": function (newValue, oldValue) {
      if (newValue !== oldValue) {
        if (newValue) {
          base64Encode(newValue)
            .then(value => {
              this.pdfPreview = value;
            })
            .catch(() => {
              this.pdfPreview = null;
            });
        } else {
          this.pdfPreview = null;
        }
      }
    }
  },
  mounted() {
    this.getRelaties(),
    this.getProfile()

  },
  methods: {
    changeRelatie(relatie) {
      // contactpersoon deselecteren
      this.$set(this.nieuwdocument, "aanContactpersoon", null);
      this.getContactpersonen(relatie);
    },
    getContactpersonen(b) {
      console.log(b);
      var vm = this;
      this.get(`/relatie/${b.Id}/contactpersonen`)
        .then(function (response) {
          vm.contactpersonen = response.data.contactpersonen;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    
    startDirectUpload() {
      this.busy = true;
      var vm = this;
      var formdata = new FormData();
      formdata.append("file_content", this.nieuwdocument.document);
      formdata.append("file_name", this.nieuwdocument.document.name);

      // doc fields
      formdata.append("documentType",this.nieuwdocument.documentType);
      formdata.append("documentStatus",this.nieuwdocument.documentStatus);
      formdata.append("documentTonen",this.nieuwdocument.documentTonen);
      formdata.append("soortOnderhoud",this.nieuwdocument.soortOnderhoud);
      formdata.append("verzenddatum",this.nieuwdocument.verzenddatum);
      formdata.append("bedrag",this.nieuwdocument.bedrag);
      formdata.append("kenmerk",this.nieuwdocument.kenmerk);
      formdata.append("opmerking",this.nieuwdocument.opmerking);
      formdata.append("vanRelatie",this.nieuwdocument.vanRelatie);
      formdata.append("aanRelatie",this.nieuwdocument.aanRelatie);
      formdata.append("aanContactpersoon",this.nieuwdocument.aanContactpersoon);
  
      this.uploadDocument(this.uploadAPIPath, formdata)
        .then(function (response) {
          vm.uploadResponse = response.data
          console.log(response.data);
          vm.$router.push({ name: "Document", params: { id: vm.uploadResponse.document.ID, jaar: new Date().getUTCFullYear() }})
        })
        .catch(function (error) {
          vm.uploadResponse = error
          console.log(error);
        })
        .finally(() => { 
          vm.busy = false 
        });
    },
    uploadDocument(endpoint, data) {
      return this.postMultipart(endpoint, data);
    },
    
    getRelaties() {
      var vm = this;
      this.busy = true;
      this.get("/relaties")
        .then(function (response) {
          vm.relaties = response.data.relaties;
        })
        .finally(() => (vm.busy = false));
    },
    getProfile() {
      var vm = this;
      this.get("/user/profile")
        .then(function(response) {
           vm.profiel = response.data;
        })
        .catch(function(error) {
          console.log(error)
          // vm.profiel = error;
        });
    },
  },
};
</script>

<style scoped>
#pdf-scroll {
  position: relative;
  overflow-y: scroll;
}
</style>